<template>
  <div>
    <el-dialog
      title="编辑"
      :visible.sync="getter_currentEditedBox"
      width="50%"
      @close="closeAddwindow"
    >
      <div class="wrapper_addBox">
        <div class="addBox_content">
          <el-form
            ref="elForm"
            :model="formData"
            :rules="rules"
            size="small"
            label-width="100px"
          >
            <el-form-item label="名称" prop="name">
              <el-input
                v-model="formData.name"
                placeholder="请输入单行文本"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="显示名称" prop="showName">
              <el-select v-model="formData.showName" placeholder="请选择下拉选择" clearable :style="{width: '100%'}">
                <el-option v-for="(item, index) in showNameOptions" :key="index" :label="item.label"
                           :value="item.value" :disabled="item.disabled"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="应急卡" prop="emcy">
              <el-select
                v-model="formData.emcy"
                placeholder="请选择下拉选择"
                clearable
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in emcyOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="应知卡" prop="shoulKnow">
              <el-select
                v-model="formData.shoulKnow"
                placeholder="请选择下拉选择"
                clearable
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in shoulKnowOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="承诺卡" prop="promiseCard">
              <el-select
                v-model="formData.promiseCard"
                placeholder="请选择下拉选择"
                clearable
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in promiseCardOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域" prop="dangerInfo">
              <el-select
                v-model="formData.dangerInfo"
                placeholder="请选择下拉选择"
                clearable
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in alldangerArea"
                  :key="index"
                  :label="item.cellName"
                  :value="item.id"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="风险等级" prop="riskLevel">
            <el-select v-model="formData.riskLevel" placeholder="请选择下拉选择" clearable :style="{width: '100%'}">
              <el-option v-for="(item, index) in riskLevelOptions" :key="index" :label="item.label"
                :value="item.value" :disabled="item.disabled"></el-option>
            </el-select>
          </el-form-item> -->
            <el-form-item label="模型地址" prop="modelUrl">
              <el-input
                v-model="formData.modelUrl"
                placeholder="请输入单行文本"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="高度" prop="hight">
              <el-input
                v-model="formData.hight"
                placeholder="请输入单行文本"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: center">
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="closeAddwindow">关闭</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import * as BoxAPI from "../../../api/BoxData";
import { Color } from "cesium";
import cesiumUtil from "@/utils/cesiumUtils";
export default {
  components: {},
  props: {},
  data() {
    return {
      formData: {
        name: "",
        showName:false,
        emcy: undefined,
        shoulKnow: undefined,
        promiseCard: undefined,
        dangerInfo: undefined,
        riskLevel: undefined,
        modelUrl: undefined,
        hight: undefined,
      },
      visual: false,
      rules: {},
      editedEntity: null,
      emcyOptions: [],
      shoulKnowOptions: [],
      promiseCardOptions: [],
      dangerInfoOptions: [],
      showNameOptions:[
        {
          label: "显示",
          value: 1,
        },
        {
          label: "隐藏",
          value: 0,
        }
      ],
      riskLevelOptions: [
        {
          label: "低风险",
          value: 1,
        },
        {
          label: "一般风险",
          value: 2,
        },
        {
          label: "较大风险",
          value: 3,
        },
        {
          label: "重大风险",
          value: 4,
        },
      ],
      riskLevel: 0,
      alldangerArea: [],
    };
  },
  computed: {
    getDangerInfo() {
      return this.formData.dangerInfo;
    },
    ...mapGetters({
      getter_isAdd: "getter_isAdd",
      getter_currentEditedBox: "getter_currentEditedBox",
    }),
  },
  watch: {
    getDangerInfo: {
      handler: function (newVal, oldVal) {
        let that = this;
        let result = that.alldangerArea.filter(function (area) {
          return Number(area.id) == Number(newVal);
        });
        that.riskLevel = result[0].riskLevel || 0;
      },
    },
  },
  created() {
    let that = this;
    // if(this.getter_isAdd){
    //获取区域
    BoxAPI.getAllArea().then(function (res) {
      let datas = res.data.data;
      // that.handleOptions(datas,that.dangerInfoOptions);
      that.alldangerArea = datas;
      // console.log("区域",res);
    });
    //获取承诺卡
    BoxAPI.getAllPromisecard().then(function (res) {
      let datas = res.data.data;
      that.handleOptions(datas, that.promiseCardOptions);
      // console.log("承诺卡",res);
    });
    //获取应知卡
    BoxAPI.getAllShouldknowcaSrd().then(function (res) {
      let datas = res.data.data;
      // debugger;
      that.handleOptions(datas, that.shoulKnowOptions);
      // console.log("应知卡",res);
    });
    //获取应急卡
    BoxAPI.getAllEmergencycard().then(function (res) {
      let datas = res.data.data;
      that.handleOptions(datas, that.emcyOptions);
      // console.log("应急卡",res);
    });

    // }else{
    let _data = this.getter_currentEditedBox;
    // debugger;
    this.editedEntity = _data;
    this.formData = {
      id: _data.id,
      name: _data.name,
      showName: _data.showName,
      emcy: _data.emcyId,
      shoulKnow: _data.shoulKnowId,
      promiseCard: _data.promiseCardId,
      dangerInfo: _data.dangerInfoId,
      riskLevel: _data.riskLevel,
      modelUrl: _data.modelUrl,
      hight: _data.hight,
    };

    // }
  },
  mounted() {},
  methods: {
    ...mapActions({
      change_currentAttributeDrawed: "change_currentAttributeDrawed",
      change_addBoxWindow_Visual: "change_addBoxWindow_Visual",
    }),
    handleOptions(_datas, _selectOptions) {
      for (let i = 0; i < _datas.length; i++) {
        _selectOptions.push({
          label: _datas[i].name ? _datas[i].name : _data[i].cellName,
          value: _datas[i].id,
        });
      }
    },
    submitForm() {
      let formData = this.formData;
      let _that = this;
      // debugger;
      let options = {
        id: formData.id,
        name: formData.name,
        showName:formData.showName,
        emcyId: formData.emcy,
        shoulKnowId: formData.shoulKnow,
        promiseCardId: formData.promiseCard,
        dangerInfoId: formData.dangerInfo,
        riskLevel: _that.riskLevel || 0,
        modelUrl: formData.modelUrl,
        hight: formData.hight,
      };
      if (!this.getter_isAdd) {
        let colorEnum = {
          0: Color.RED,
          1: Color.ORANGE,
          2: Color.YELLOW,
          3: Color.BLUE,
        };
        // this.editedEntity.entity.polygon.extrudedHeight = Number(options.hight);
        // this.editedEntity.entity.polygon.material = colorEnum[
        //   options.riskLevel
        // ].withAlpha(0.2);
        let coors = "";
        for (let i = 0; i < this.editedEntity.coors.length; i++) {
          let lonlat = this.editedEntity.coors[i].coor;
          coors += `${lonlat[0]},${lonlat[1]};`;
        }
        options = Object.assign(options, {
          coor: coors
        });
        let data = BoxAPI.editBox(options).then((res) => {
          _that.$parent.$refs.boxer.getAll();
          _that.change_addBoxWindow_Visual({ visual: false });
        });
      }else {
        //将属性传入，结合坐标；绘制罩子同时将数据插入接口
        _that.change_currentAttributeDrawed({ info: options });
      }
    },
    closeAddwindow() {
      this.change_addBoxWindow_Visual({ visual: false });
    },
  },
};
</script>
<style scoped>
/deep/ .el-dialog {
  margin-top: 200px !important;
  height: 60%;
  background: #ffffff;
  border-radius: 2px;
}
/deep/ .el-dialog__header {
  height: 40px;
  background: #f5f5f5;
  padding: 0;
  text-align: center;
  line-height: 40px;
}
/deep/ .el-dialog__body{
  height: calc(100% - 40px);
}
.el-dialog__title {
  line-height: 40px;
  color: #333333;
  font-size: 16px;
  font-weight: 500;
}
/deep/ .el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: 10px;
}
.wrapper_addBox {
  background-color: #fff;
  padding: 15px;
  border: 1px solid #ebeef5;
}
.addBox_content {
  margin: 0 auto;
  width: 90%;
  height: 100%;
  background: #fff;
  padding: 10px;
}
.addBox_content .el-form-item__label {
  color: black !important;
  text-align: center !important;
}
</style>
